import script from "./FooterNav.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterNav.vue?vue&type=script&lang=ts&setup=true"

import "./FooterNav.vue?vue&type=style&index=0&id=d49e482a&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d49e482a"]])

export default __exports__